export default "__VITE_ASSET__DmOu1Kiq__"